import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SearchState {
  searchDate: { startDate: string; endDate: string };
  totalGuests: number;
  userLocation: any;
  searchedData: any;
}

const initialState: SearchState = {
  searchDate: { startDate: "", endDate: "" },
  totalGuests: 0,
  userLocation: { latitude: null, longitude: null },
  searchedData: {
    startDate: "",
    endDate: "",
    totalGuests: 0,
    latitude: null,
    longitude: null,
    address: "",
    searchedResult: null,
    locationData: null,
    roomTypeId: "",
    propertyTypeId: "",
    selectedAmenitiesId: [],
    priceMin: 0,
    priceMax: 5000,
    bedroom: "",
    bathroom: "",
    propertyCategories: [],
    feature: [],
  },
};

const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    setSearchData: (state, action: PayloadAction<any>) => {
      const {
        startDate,
        endDate,
        totalGuests,
        latitude,
        longitude,
        label,
        locationData,
        searchedResult,
        roomTypeId,
        propertyTypeId,
        selectedAmenitiesId,
        priceMin,
        priceMax,
        bedroom,
        bathroom,
        propertyCategories,
        feature,
      } = action.payload;
      state.searchedData = {
        ...state.searchedData,
        startDate,
        endDate,
        totalGuests,
        latitude,
        longitude,
        label,
        locationData,
        searchedResult,
        roomTypeId,
        propertyTypeId,
        selectedAmenitiesId,
        priceMin,
        priceMax,
        bedroom,
        bathroom,
        propertyCategories,
        feature,
      };
    },
    // ✅ NEW: Clear all search filters
    clearSearchFilters: (state) => {
      // Reset to initial state but keep location data if needed
      state.searchedData = {
        ...initialState.searchedData,
        // Optionally keep the location
        latitude: state.searchedData.latitude,
        longitude: state.searchedData.longitude,
        locationData: state.searchedData.locationData,
      };
      state.searchDate = initialState.searchDate;
      state.totalGuests = initialState.totalGuests;
    },
    // ✅ NEW: Clear all including location (complete reset)
    resetSearch: (state) => {
      return initialState;
    },
  },
});

export const { setSearchData, clearSearchFilters, resetSearch } = searchSlice.actions;

export default searchSlice.reducer;